import { defineStore } from 'pinia';
import { SUPPLEMENT_PLAN, SUPPLEMENT_STAGE } from '../common/constants/supplement';
import type { SupplementStateModel } from '../interfaces/supplement.interface';

export const useSupplementStore = defineStore('supplement', {
  state: (): SupplementStateModel => ({
    arm: null,
    stage: SUPPLEMENT_STAGE.NONE,
    plan: SUPPLEMENT_PLAN.THREE_MONTHS,
    address: null,
  }),

  persist: {
    arm: { local: 'supplement_arm' },
    stage: { local: 'supplement_stage' },
    plan: { local: 'supplement_plan' },
    address: { local: 'supplement_address' },
  },
});
